export const isValidLocationId = (id?: string): boolean => !!id && id !== 'index.html' && id !== 'softpay-android';

export const isValidNumericLocationId = (id?: number): boolean => id !== undefined && id > 0;
